import AppError from './AppError';
const AppDateData = {};
export const AppDate = {
    initCache(cacheWrapperService, envPrefix) {
        if (!AppDateData.cacheWrapper) {
            AppDateData.cacheWrapper = {
                cacheKey: `${envPrefix}-global-app-date`,
                cacheWrapperService: cacheWrapperService,
            };
            Object.freeze(AppDateData.cacheWrapper);
            return true;
        }
        else {
            throw AppError.createNewError('AppDateCacheAlreadyInitialized');
        }
    },
    getDate() {
        const _cachedTimestamp = AppDateData.localTimestamp;
        if (Number.isInteger(_cachedTimestamp)) {
            return new Date(_cachedTimestamp);
        }
        else {
            return new Date();
        }
    },
    async updateDateFromCache() {
        if (AppDateData.cacheWrapper) {
            const _cachedTimestamp = parseInt(await AppDateData.cacheWrapper.cacheWrapperService.getCache(AppDateData.cacheWrapper.cacheKey));
            if (Number.isInteger(_cachedTimestamp)) {
                AppDateData.localTimestamp = _cachedTimestamp;
                return true;
            }
            else {
                AppDateData.localTimestamp = undefined;
            }
        }
        return false;
    },
    async setDate(timestamp) {
        const _timestamp = timestamp instanceof Date ? timestamp.getTime() : timestamp;
        if (Number.isInteger(_timestamp)) {
            if (AppDateData.cacheWrapper) {
                await AppDateData.cacheWrapper.cacheWrapperService.setCache(AppDateData.cacheWrapper.cacheKey, _timestamp.toString());
            }
            AppDateData.localTimestamp = _timestamp;
            return true;
        }
        else {
            throw AppError.createNewError('PassedTimestampMustBeIntegerOrDate');
        }
    },
    setDateWithoutCache(timestamp) {
        const _timestamp = timestamp instanceof Date ? timestamp.getTime() : timestamp;
        if (Number.isInteger(_timestamp)) {
            AppDateData.localTimestamp = _timestamp;
            return true;
        }
        else {
            throw AppError.createNewError('PassedTimestampMustBeIntegerOrDate');
        }
    },
    async resetDate() {
        if (AppDateData.cacheWrapper) {
            await AppDateData.cacheWrapper.cacheWrapperService.deleteCache(AppDateData.cacheWrapper.cacheKey);
        }
        AppDateData.localTimestamp = undefined;
        return true;
    },
    resetDateWithoutCache() {
        AppDateData.localTimestamp = undefined;
        return true;
    },
    realNow() {
        return new Date();
    },
    realNowTimestamp() {
        return AppDate.realNow().getTime();
    },
};
export default AppDate;
